var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.link)?_c('div',{staticClass:"prepayment-calc",on:{"click":_vm.goPrepaymentCalc}},[_vm._v("我想提前还款？")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }